export default __webpack_public_path__ + "static/motel-bathroom2-8c79af9b4a1bf9f48c1d4b08c407934a.jpg";